import { createContext, useContext } from 'react';

const AddItemContext = createContext<{ addItem: (item) => void; canAdd: boolean }>(undefined);

const AddItemProvider = AddItemContext.Provider;
const AddItemConsumer = AddItemContext.Consumer;
const useAddItem = () => useContext(AddItemContext);

export { AddItemProvider, AddItemConsumer, useAddItem };
